export default __webpack_public_path__ + "static/media/selected.eeaa784f.svg";